/*------------------------------------*\
    MODULES
\*------------------------------------*/
import autoComplete from '@tarekraafat/autocomplete.js';
import 'whatwg-fetch';

/*------------------------------------*\
    HORSES IN TRAINING AUTOCOMPLETE
\*------------------------------------*/
class HorsesInTrainingAutocomplete {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.elemId = self.elem.getAttribute('id');
    }

    init() {
        let self = this;

        // Fetch the horse data
        fetch('/api/horses-in-training.json')
            .then(function (response) {
                return response.json();
            }).then(function (json) {
                // Init autoComplete
                self.initAutocomplete(json);
            }).catch(function (ex) {
                console.log('Parsing failed', ex);
            });
    }

    initAutocomplete(json) {
        let self = this;

        // Convert the horse data to a simple array
        const data = [];

        json.data.forEach(item => {
            data.push(item.name)
        });

        // Init autoComplete
        const autoCompleteJS = new autoComplete({
            placeHolder: "STARTING TYPING NAME...",
            selector: `#${self.elemId}`,
            resultsList: {
                class: 'autocomplete-list'
            },
            resultItem: {
                highlight: true
            },
            data: {
                src: data
            },
            events: {
                input: {
                    selection: (event) => {
                        const selection = event.detail.selection.value;
                        autoCompleteJS.input.value = selection;
                    }
                }
            }
        });
    }
}

export default HorsesInTrainingAutocomplete;
